import { ContactMethod } from './ContactMethod';
import { ContactListItem } from './ContactListItem';

export class Contact extends ContactListItem {
    ContactMethods: ContactMethod[];
}
